<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.is-multiline.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title SCA TPA &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns.has-text-centered.is-centered.is-mobile
          .column.is-3-desktop.is-4-mobile-desktop.is-4-mobile(v-show="verNominaciones")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Nominaciones
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to='/TPA/SCA/Nominaciones') Entrar
          .column.is-3-desktop.is-4-mobile(v-show="verCuartoControl")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Cuarto de Control
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to='/TPA/SCA/CuartoControl') Entrar
          .column.is-3-desktop.is-4-mobile(v-show="verBascula")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-weight.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Báscula
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Bascula") Entrar
        .columns.has-text-centered.is-centered.is-mobile
          .column.is-3-desktop.is-4-mobile(v-show="verDocumentacion")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-invoice-dollar.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Documentación
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Documentacion") Entrar
          .column.is-3-desktop.is-4-mobile(v-show="verAccesos")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-truck-moving.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Accesos
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Accesos") Entrar
          .column.is-3-desktop.is-4-mobile(v-show="verBitacora")
            .card
              .card-content
                span.icon.is-large.is-size-6.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-book.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5.is-size-5 Bitácora
                br
                router-link.a.button.is-dark.is-rounded.is-size-6.is-size-6(to="/TPA/SCA/Bitacora") Entrar
          .column.is-3-desktop.is-4-mobile(v-show="verDashboard")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-table.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Dashboard
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Dashboard") Entrar
</template>

<script>
  import NavBar from "./layout/NavBar.vue"
  import Loader from "@/components/shared/Loader.vue"
  import { mapState } from 'vuex'
  export default {
    name: 'MenuIRGE',
    components: { Loader, NavBar },
    data() {
      return {
        isLoading: true,
        verNominaciones: false,
        verBascula: false,
        verCuartoControl: false,
        verDocumentacion: false,
        verInventarios: false,
        verAccesos: false,
        verBitacora: false,
        verDashboard: false,
      }
    },
    methods: {
      iniciarComponente () {
        switch (this.permisos.sca_tpa) {
          case 1:
            this.verNominaciones = true
            this.verBascula = true
            this.verCuartoControl = true
            this.verDocumentacion = true
            this.verAccesos = true
            this.verDashboard = true
            this.verBitacora = true
            break
          case 2:
            return
            break
          case 3:
            this.verAccesos = true
            break
          case 4:
            this.verDocumentacion = true
            break
          case 5:
            this.verCuartoControl = true
            break
          case 6:
            this.verBascula = true
            break
          case 7:
            this.verNominaciones = true
            this.verBascula = true
            this.verCuartoControl = true
            this.verDocumentacion = true
            this.verAccesos = true
            break
          case 8:
            this.verAccesos = true
            this.verBascula = true
            this.verCuartoControl = true
            this.verDocumentacion = true
            break
          case 9:
            break
          case 10:
            break
          case 11:
            break
          case 12:
            this.verCuartoControl = true
            break
          case 13:
            this.verDocumentacion = true
            break
          case 14:
            this.verCuartoControl = true
            this.verBascula = true
            break
          default: 
            break
        }
        this.isLoading = false
      },

      backPage() {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/tpa_components/Menu.vue